import { Avatar, Grid } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import TableIcon from "../../../../../assets/images/table.png";
import TableDailog from "./TableDailog";

const infos = [
  "B00",
  "B01",
  "B02",
  "B03",
  "B04",
  "B05",
  "B06",
  "B07",
  "B08",
  "B09",
  "B10",
  "B11",
  "B12",
  "B13",
  "B14",
  "B15",
  "B16",
  "B17",
  "B18",
  "B19",
];

const AllTables = () => {
  const navigate = useNavigate();
  // Dailog Part
  const [open, setOpen] = React.useState(false);
  const [table, setTable] = React.useState();

  const handleClickOpen = (value) => {
    console.log("AA: " + open);
    setOpen(true);
    setTable(value);
  };
  const handleClose = () => {
    setOpen(false);
    navigate("/order-page");
  };
  // Dailog Part

  return (
    <div>
      <PageContentBox infos={infos} handleClickOpen={handleClickOpen} />
      <TableDailog open={open} handleClose={handleClose} table={table} />
    </div>
  );
};

const PageContentBox = ({ infos, handleClickOpen }) => (
  <div style={{ width: 1079, display: "flex", justifyContent: "center" }}>
    <div style={{ width: 1019, marginTop: 30 }}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        {infos.map((item, index) => (
          <SingleTable
            item={item}
            handleClickOpen={handleClickOpen}
            key={index}
          />
        ))}
      </Grid>
    </div>
  </div>
);

const SingleTable = ({ item, handleClickOpen }) => (
  <div
    style={{
      background: "#FFFFFF",
      width: 192,
      height: 138,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: 15,
      cursor: "pointer",
    }}
    onClick={() => handleClickOpen(item)}
  >
    <Avatar
      sx={{
        width: "72px",
        height: "57px",
      }}
      variant="square"
      src={TableIcon}
    />

    <div
      style={{
        color: "#333C4B",
        fontSize: 16,
        fontWeight: "500",
        fontFamily: `Poppins, sans-serif`,
      }}
    >
      Table {item}
    </div>
  </div>
);

export default AllTables;
